import { useReducer } from 'react';
export function useLocalStorage(...localStorageKeys) {
    return useReducer((_, newValue) => {
        if (newValue === null) {
            localStorageKeys[0] && window.localStorage.removeItem(localStorageKeys[0]);
        }
        else {
            localStorageKeys.forEach((key) => window.localStorage.setItem(key, newValue));
        }
        return newValue;
    }, null, () => {
        for (const key of localStorageKeys) {
            const value = window.localStorage.getItem(key);
            if (value !== null) {
                return value;
            }
        }
        return null;
    });
}
//# sourceMappingURL=useLocalStorage.js.map